import "../css"
import Modal from "bootstrap/js/dist/modal"

let modal

addEventListener("click", ({ target }) => {
  if (target.matches("[data-full]")) {
    document.querySelector(".modal-body").innerHTML = `<img src="${target.dataset.full}" class="w-100">`
    if (!modal) {
      modal = new Modal("#photo-large")
    }
    modal.show()
  }
})

addEventListener("turbo:before-cache", () => {
  modal = null
})
